const config = {
	pageSize: 25,
};

export default config;
